export default "__VITE_ASSET__CWlYWsz5__"